import {
  compose,
  pure
} from 'recompose'
import React from 'react'
import Moment from 'react-moment'
import {
  Pagination,
  Loader,
  Modal
} from '../../uiLib'
import CartTable from '../../CartTable'
import { withI18next } from '../../../lib/withI18next'
import Link from 'next/link'

const Orders = props => {
  return (
    <React.Fragment>
      {
        !props.list.length && !props.loading ? <p className="m-b-md">{props.t('no-results')}</p> : null
      }
      { props.loading &&
        <Loader className="order-history-list-loader" />
      }
      {
        !!props.list.length && !props.loading && props.list.map(item => (
          <div className="order-history-list m-b-md" key={item.id}>
            <table className="table is-fullwidth">
              <tbody>
                <tr>
                  <td>{props.t('order-date')}:</td>
                  <td><Moment format="MM/DD/YYYY hh:mm:ss A">{item.order_date}</Moment></td>
                </tr>
                <tr>
                  <td>{props.t('payflow-trans-id')}</td>
                  <td>
                    {item.payflow_trans_id}&nbsp;
                    <Link href="/contact"><a>{props.t('refund-order')}</a></Link>
                  </td>
                </tr>
              </tbody>
            </table>
            <CartTable
              cart={{ items: item.order_items.map(item => ({
                  id: item.product_id,
                  price: item.price
                }))
              }}
              subtotal={item.order_subtotal}
              tax={item.order_tax}
              total={item.order_total}
            />
            <Modal
              isShown={item.id === props.selectedRefundModalId}
              title={props.t('refund-order')}
              bodyContent={props.t('refund-modal-body')}
              onCancelClick={() => props.hideRefundModal()}
              cancelBtnText={props.t('cancel')}
              onConfirmClick={e => props.confirmRefundRequestSubmit(e, item)}
              confirmBtnText={props.t('OK')}
              loading={props.isRefundRequestInProgress}
            />
          </div>
        ))
      }
      <Pagination
        pageCount={props.pageCount}
        onPageChange={selected => props.handlePageClick(selected, props.userId)}
        initialPage={props.initialPage}
        isSmall
      />
    </React.Fragment>
  )
}

Orders.defaultProps = {
  list: []
}

export default compose(
  withI18next('common'),
  pure
)(Orders)



// WEBPACK FOOTER //
// ./components/Common/UserDetails/Orders.js